import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const GetStarted = () => {
  return (
    <section className="get-started-section index9">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-header text-center">
                <h2 className="title">Turn payouts into a clear P&amp;L</h2>
                <p>
                  Connect your existing OracleMarket activity, pick the metrics you
                  care about, and get a living earnings story—not a once-a-month
                  scramble through PDFs.
                </p>
                <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
                  Start tracking insights
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
